import {Message, IMessage, MessageTextConverter} from "./Message";


export interface IButtonReplyMessage extends IMessage {

    Reply : IButton

}

export interface IButton {
    Id: string;
    Title: string;
}

export const ButtonReplyMessage = (props: IButtonReplyMessage) => {

    //Find all ReplyButtonMessages with this button and mark them done

    return <Message {...props}>
        {MessageTextConverter.parse(props.Reply.Title)}
    </Message>
}